import { useTranslation } from "react-i18next";

import type { PartnerHookSlot } from "../lib/partner-script-production";

/** The hook's voiceover and on-screen text, each shown only when set. */
export function PartnerHookSlotFields({ slot }: { slot: PartnerHookSlot }) {
  const { t } = useTranslation();

  return (
    <dl className="grid grid-cols-[7rem_1fr] gap-x-3 gap-y-1.5 text-xs">
      {slot.voiceover ? (
        <div className="contents">
          <dt className="text-muted-foreground">
            {t("marketplace.partner.workspace.hookVoiceover", "Voiceover")}
          </dt>
          <dd className="whitespace-pre-wrap text-foreground">{slot.voiceover}</dd>
        </div>
      ) : null}
      {slot.onScreenText ? (
        <div className="contents">
          <dt className="text-muted-foreground">
            {t("marketplace.partner.workspace.hookOnScreenText", "On-screen text")}
          </dt>
          <dd className="whitespace-pre-wrap text-foreground">{slot.onScreenText}</dd>
        </div>
      ) : null}
    </dl>
  );
}
